import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("button", {
    class: _normalizeClass([$props.variant, $props.size, 'relative flex items-center justify-center cursor-pointer outline-none font-normal', {
      'flex-row-reverse': $props.reversed
    }, {
      'px-0! aspect-square': !$props.text
    }, $props.rounded ? 'rounded-full' : 'rounded-md', $props.stretch ? 'w-full' : 'w-fit', {
      'pointer-events-none': $props.loading || $props.disabled
    }, {
      'selected': $props.selected
    }]),
    onClick: _cache[0] || (_cache[0] = $event => {
      $props.callback && !$props.disabled && !$props.loading ? $props.callback() : undefined;
      $event.currentTarget.parentElement.focus();
    }),
    disabled: $props.disabled
  }, [$props.loading ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    id: "button-loader",
    class: _normalizeClass(['border-2 rounded-full animate-spin aspect-square', 'loading-spinner-' + $props.variant])
  }, null, 2)) : (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: _normalizeClass(['flex items-center gap-2.5', {
      'flex-row-reverse': $props.reversed
    }])
  }, [$props.text ? (_openBlock(), _createElementBlock("p", {
    key: 0,
    innerHTML: $props.text,
    class: "whitespace-nowrap"
  }, null, 8, _hoisted_2)) : _createCommentVNode("", true), $props.icon ? (_openBlock(), _createElementBlock("i", {
    key: 1,
    id: "icon",
    class: _normalizeClass(["text-current", $props.icon]),
    style: _normalizeStyle([`transform: rotate(${$props.rotateicon}deg)`])
  }, null, 6)) : _createCommentVNode("", true), $props.image ? (_openBlock(), _createElementBlock("img", {
    key: 2,
    id: "icon",
    src: $props.image,
    style: _normalizeStyle([`transform: rotate(${$props.rotateicon}deg)`])
  }, null, 12, _hoisted_3)) : _createCommentVNode("", true)], 2)), _renderSlot(_ctx.$slots, "default", {}, undefined, true)], 10, _hoisted_1);
}